export const config = {
  title: "R&M FAYHASON Janitorial Services | Professional Cleaning in Manteca, CA",
  meta: {
    description:
      "R&M FAYHASON Janitorial Services offers reliable, high-quality cleaning solutions for residential and commercial properties in Manteca, CA, and surrounding areas.",
    keywords: [
      "Manteca CA cleaning services",
      "R&M FAYHASON Janitorial Services",
      "commercial cleaning Manteca",
      "residential cleaning Manteca",
      "janitorial services California"
    ],
    author: "R&M FAYHASON Janitorial Services",
    canonicalUrl: "https://rmfayhasonjanitorialservices.com/",
  },
  sections: {
    header: {
      businessName: "R&M FAYHASON Janitorial Services",
    },
    sectionB: {
      heroTitle: "R&M FAYHASON Janitorial Services",
      heroSubtitle: "Your Trusted Partner for Professional Cleaning in Manteca, CA",
      learnAboutText: "Request a Quote",
      phoneNumber: "8604612724",
      phoneLabel: "(860) 461-2724",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2194825907/photo/close-up-of-cleaning-cart-with-detergents-cleaning-mop-and-bucket-in-shopping-mall-with.jpg?s=612x612&w=0&k=20&c=dHjPDkIdQ-xpTs9l-G2EEH8-Zr1BysfiDw4zI0mpeV8=",
      cardData: [
        {
          title: "Commercial Cleaning",
          description: "Comprehensive cleaning services for offices, retail spaces, and more.",
        },
        {
          title: "Residential Cleaning",
          description: "Tailored home cleaning solutions for a spotless living space.",
        },
        {
          title: "Floor & Carpet Care",
          description: "Expert floor polishing, carpet cleaning, and maintenance.",
        },
      ],
      description:
        "Serving Manteca and surrounding areas, R&M FAYHASON Janitorial Services delivers dependable cleaning solutions for businesses and homes, with a commitment to quality and client satisfaction.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From routine maintenance to deep cleaning, our team ensures your space is spotless and inviting.",
      cards: [
        {
          title: "Office & Workspace Cleaning",
          description: "Daily, weekly, or monthly cleaning schedules tailored to your needs.",
          imageSrc: "https://media.istockphoto.com/id/2098028629/photo/janitor-use-floor-scrubber-machine-on-the-floor-hallway-office-building-or-walkway-after.jpg?s=612x612&w=0&k=20&c=nGqDn5fxE4WwZmg65RtZ8o_lWv1fb8xcLYPalsfMy0M=",
          imageAlt: "Office Cleaning",
        },
        {
          title: "Residential Deep Cleaning",
          description: "Detailed cleaning for kitchens, bathrooms, and living areas.",
          imageSrc: "https://media.istockphoto.com/id/1417035967/photo/soaking-and-washing-furniture.jpg?s=612x612&w=0&k=20&c=WrEh6OOZEcK3qeAbnu15s3bgEf_3x3Z8WXllPQoK7NI=",
          imageAlt: "Residential Cleaning",
        },
        {
          title: "Floor & Carpet Care",
          description: "Professional care for all types of flooring and carpets.",
          imageSrc: "https://media.istockphoto.com/id/2165677748/photo/cleaning-agency-worker-in-overalls-operates-vacuum-on-living-room-carpet.jpg?s=612x612&w=0&k=20&c=aikaXxnqFNKkFAl8Y38uJ_l3ltXGUct70Zixm1M5ES8=",
          imageAlt: "Floor and Carpet Care",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Experienced Cleaning Professionals",
        "Eco-Friendly Cleaning Products",
        "Flexible Scheduling",
        "Attention to Detail",
        "100% Satisfaction Guarantee",
      ],
    },
    sectionD: {
      aboutTitle: "About R&M FAYHASON Janitorial Services",
      aboutImage: {
        src:
          "https://rmfayhasonjanitorialservices.com/img/logo.png",
        alt: "R&M FAYHASON Janitorial Services Team",
      },
      aboutText: [
        "R&M FAYHASON Janitorial Services is committed to delivering exceptional cleaning services to both commercial and residential clients.",
        "With a focus on customer satisfaction, our trained professionals ensure every job is done to the highest standard.",
      ],
    },
    sectionE: {
      profileImage: "https://rmfayhasonjanitorialservices.com/img/logo.png",
      profileAlt: "R&M FAYHASON Janitorial Services Logo",
      businessName: "R&M FAYHASON Janitorial Services",
      contact: {
        phone: "8604612724",
        phoneLabel: "(860) 461-2724",
        email: "manuel.j.mardales@gmail.com",
        website: "https://rmfayhasonjanitorialservices.com/",
        address: "Manteca, CA, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Manteca, CA, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3175.947!2d-121.2161!3d37.7974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80901808d45b73a5%3A0x9e3a8af0a2ddf3b5!2sManteca%2C%20CA!5e0!3m2!1sen!2sus!4v1710000000000",
    },
  },
};

export default config;
